import { cn } from '@/lib/utils';

interface SpinnerProps {
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-b-2',
  lg: 'h-8 w-8 border-4', // Use standard border-4 for overall width
};

export default function Spinner({ text, size = 'md', className }: SpinnerProps) {
  const spinnerElement = (
    <div
      className={cn(
        'animate-spin rounded-full border-primary border-b-transparent', // Use primary color, make bottom border transparent for a nicer effect
        sizeClasses[size],
        className,
      )}
    />
  );

  if (!text) {
    return spinnerElement;
  }

  // If text is provided, render spinner above the text
  return (
    <div className="flex flex-col items-center gap-2">
      {spinnerElement}
      <span className="text-sm text-muted-foreground">{text}</span>
    </div>
  );
}
